import { createClient } from '@libsql/client';
import { nanoid } from 'nanoid';

const db = createClient({
  url: import.meta.env.VITE_TURSO_DB_URL,
  authToken: import.meta.env.VITE_TURSO_AUTH_TOKEN
});

const DEFAULT_HOW_IT_WORKS_CONTENT = {
  lastUpdated: new Date().toISOString(),
  pageTitle: "How It Works",
  pageSubtitle: "Simple steps to find and purchase your dream property",
  sections: [
    {
      id: "steps",
      name: "How It Works Steps",
      items: [
        {
          id: nanoid(),
          number: "01",
          title: "Browse Properties",
          description: "Explore our curated collection of premium properties across India."
        },
        {
          id: nanoid(),
          number: "02",
          title: "Schedule Viewing",
          description: "Book a convenient time to visit and inspect your chosen properties."
        },
        {
          id: nanoid(),
          number: "03",
          title: "Documentation",
          description: "We handle all the paperwork and legal documentation for you."
        },
        {
          id: nanoid(),
          number: "04",
          title: "Get Your Keys",
          description: "Complete the transaction and move into your new home."
        }
      ]
    }
  ]
};

const ensureTableExists = async () => {
  try {
    await db.execute(`
      CREATE TABLE IF NOT EXISTS how_it_works_content (
        id TEXT PRIMARY KEY,
        content_data TEXT NOT NULL,
        updated_at TEXT NOT NULL
      );
    `);
  } catch (error) {
    console.error("Error ensuring how_it_works_content table exists:", error);
  }
};

const howItWorksService = {
  async getHowItWorksContent() {
    await ensureTableExists();
    try {
      const result = await db.execute({
        sql: `SELECT content_data, updated_at FROM how_it_works_content WHERE id = ?;`,
        args: ['how-it-works']
      });

      if (result.rows.length > 0) {
        const content = JSON.parse(result.rows[0].content_data);
        content.lastUpdated = result.rows[0].updated_at;
        return content;
      } else {
        console.log('No content found for How It Works, returning default and saving it.');
        await this.createOrUpdateHowItWorksContent(DEFAULT_HOW_IT_WORKS_CONTENT);
        return DEFAULT_HOW_IT_WORKS_CONTENT;
      }
    } catch (error) {
      console.error("Error fetching How It Works content:", error);
      throw new Error('Could not fetch How It Works content from database.');
    }
  },

  async createOrUpdateHowItWorksContent(content) {
    await ensureTableExists();
    const now = new Date().toISOString();
    try {
      const serializedContent = JSON.stringify({ ...content, lastUpdated: now });
      await db.execute({
        sql: `
          INSERT INTO how_it_works_content (id, content_data, updated_at) VALUES (?, ?, ?)
          ON CONFLICT(id) DO UPDATE SET content_data = ?, updated_at = ?;
        `,
        args: [
          'how-it-works',
          serializedContent,
          now,
          serializedContent,
          now
        ],
      });
      console.log('How It Works content created or updated successfully!');
      return { ...content, lastUpdated: now };
    } catch (error) {
      console.error("Error creating or updating How It Works content:", error);
      throw new Error('Could not save How It Works content to database.');
    }
  }
};

export { howItWorksService };